export default [{
  name: 'maquinas',
  namespaced: true,
  state: {
    model: {
      selecionado: {},
      Cliente: {},
      Pessoa: {
        PF: {},
        PJ: {},
        TipoPessoa: null,
        PessoaDadosContato: {},
        PessoaDadoFinanceiro: {},
        PessoaEndereco: {},
        PessoaQualificacao: {},
      },
      Descricao: '',
    }
  },
  mutations: {
    model (state, obj) {
      state.model = obj
    }
  },
  getters: {
    model (state) {
      return state.model
    }
  },
  actions: {
    clearModel ({ commit }) {
      const data = {
        selecionado: {},
        Cliente: {},
        Pessoa: {
          PF: {},
          PJ: {},
          TipoPessoa: null,
          PessoaDadosContato: {},
          PessoaDadoFinanceiro: {},
          PessoaEndereco: {},
          PessoaQualificacao: {}
        },
        Descricao: '',
      }
      commit('model', data)
    },
    beforeEach ({ getters, commit }, { to, from, next }) {
      switch (to.fullPath) {
        case '/':
          if (localStorage.ambiente) { next({ path: '/partner/' + localStorage.ambiente }) }
          break;
      }
    }
  },
  logoutFunctions: {
    // beforeClear(state) {
    //  console.log('a')
    // },
    afterClear (state) {
      location.href = '/partner/' + state.empresa.ambiente
    },
  }
}]
